import { StatsProvider } from '../StatsProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class StatsProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/stats`, headers);
  }

  public createStatsProvider(authToken: string) {
    return new StatsProvider(this.apiClientFactory.createAuthorizedClient(authToken));
  }
}
